import { apiAction } from 'apa/actions'
import * as types from 'customers/actions/types'
import { BaseUrl } from '../../BaseUrl/BaseUrl'

export const toggleActive = () => (dispatch, getState) => {
  dispatch({
    type: types.TOGGLE_ACTIVE,
    showActive: !getState().customers.showActive
  })
  dispatch(fetchCustomers())
}

export const toggleHours = () => (dispatch, getState) => {
  dispatch({
    type: types.TOGGLE_HOURS,
    showHours: !getState().customers.showHours
  })
  dispatch(fetchCustomers())
}

export const setSearchText = (searchText) => dispatch => (
  dispatch(
    {
      type: types.SET_SEARCH_TEXT,
      searchText: searchText
    }
  )
)

export const updateCustomer = (customer) => dispatch => {
  const id = customer.id
  return dispatch(apiAction({
    url: `${BaseUrl}/api/customers/${id}/`,
    method: 'PATCH',
    data: customer,
    onSuccess: response => ({
      type: types.UPDATE_CUSTOMER,
      customer: response
    }),
    onFailure: () => ({ type: 'NO' })
  }))
}

export const fetchCustomers = () => (dispatch, getState) => {
    dispatch({
        type: types.FETCH_CUSTOMER_LIST
    })
  const state = getState()
  const { showActive, searchText, currentPage, sizePerPage } = state.customers
  const data = {
    page: currentPage,
    search: searchText.length > 0 ? searchText : undefined,
    active: showActive,
    page_size: sizePerPage
  }
  return dispatch(apiAction({
    url: `${BaseUrl}/api/customers/`,
    data: data,
    onSuccess: res => (
      {
        type: types.FETCH_CUSTOMER_LIST_SUCCESS,
        customerList: res.results,
        totalCount: res.totalCount,
        pageCount: res.pageCount,
        currentPage: res.currentPage,
        sizePerPage: res.sizePerPage
      }
    )
  }))
}


export const changePage = (page = 1, sizePerPage) => (dispatch) => {
  dispatch({
    type: types.CHANGE_PAGE,
    currentPage: page,
    sizePerPage: sizePerPage
  })
  dispatch(
    fetchCustomers()
  )
}

export const fetchCustomer = (customerId, callback) => (dispatch, getState) => {
  const year = getState().items.currentYear
  dispatch(apiAction({
    url: `${BaseUrl}/api/customers/${customerId}/`,
    data: { year: year },
    onSuccess: (customer) => {
      if(callback)
        callback(customer)
      return {
        type: types.FETCH_CUSTOMER,
        customer: customer
      }
    }
  }))
}

export const fetchAttachments = (customerId) => dispatch =>
  dispatch(apiAction({
    url: `${BaseUrl}/api/customers/${customerId}/attachments/`,
    onSuccess: (attachments) => ({
      type: types.FETCH_ATTACHMENT_LIST,
      attachments: attachments
    })
  }))

export const add = (customer, history) => dispatch =>
  dispatch(apiAction({
    url: `${BaseUrl}/api/customers/`,
    method: 'POST',
    data: customer,
    onSuccess: customer => {
      history.push(`/customer/${customer.id}`)
      dispatch(fetchCustomers())
      return {
        type: types.ADD_CUSTOMER,
        customer: customer
      }
    }
  }))

  export const sortPage = (sortField, sortOrder) => (dispatch, getState) => {
      let result;
      const data = getState().customers.customerList;
      if (sortOrder === 'asc') {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
      dispatch({
        type: types.SORT_PAGE,
        customerList: result
      })
}
